export default "__VITE_ASSET__06fe8f56__"